import React from 'react';

const image = require('./images/shutterstock_219591568-9d6dbdf270b8430ba7fb053399599a13.jpg')

export default function Hero() {


    return(

        <div>
            <img src={image} width='100%' alt='sustainable coaster design'/>
        </div>
 
 
 
    )
}